import { render } from "./EventResultListItem.vue?vue&type=template&id=18e6fd2c&scoped=true"
import script from "./EventResultListItem.vue?vue&type=script&lang=js"
export * from "./EventResultListItem.vue?vue&type=script&lang=js"

import "./EventResultListItem.vue?vue&type=style&index=0&id=18e6fd2c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e6fd2c"]])

export default __exports__